import { Pagination } from "@mui/material";
import React from "react";

export default function PaginationFooter({
  tableData,
  page,
  rowsPerPage,
  handleChangePage,
}) {
  return (
    <Pagination
      count={
        Math.floor(tableData.length / rowsPerPage) +
        (tableData.length % rowsPerPage === 0 ? 0 : 1)
      }
      page={page}
      onChange={handleChangePage}
      variant="outlined"
      shape="rounded"
      size="small"
      sx={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
      }}
    />
  );
}
